<section class="result-change-page">
  <app-admin-page-header [title]="completed ? 'Resultado da alteração' : 'Alterar resultado da batalha'" subtitle="Corrija o vencedor, os pontos de liga e a premiação em gemas.">
    <div header-actions>
      <a class="admin-btn admin-btn--secondary" routerLink="/dashboard/battle-list-finished">Voltar</a>
    </div>
  </app-admin-page-header>

  <p *ngIf="isLoading" role="status">Carregando batalha…</p>
  <p *ngIf="error" class="feedback feedback--error" role="alert">{{ error }}</p>
  <p *ngIf="completed" class="feedback feedback--success" role="status">Resultado alterado com sucesso. Pontos e gemas atualizados.</p>

  <ng-container *ngIf="battle as summary">
    <section class="admin-surface detail-section">
      <h3>Resumo da batalha</h3>
      <p><strong>ID:</strong> {{ summary.id }}</p>
      <p><strong>Public ID:</strong> {{ summary.public_id }}</p>
      <p><strong>Temporada atual:</strong> {{ summary.season.name }} ({{ summary.season.id }})</p>
      <div class="players" *ngIf="!completed">
        <article *ngFor="let player of summary.players" class="player-card">
          <h4>{{ player.username }}</h4>
          <p><strong>ID do jogador:</strong> {{ player.user_id }}</p>
          <p><strong>Score:</strong> {{ player.score }}</p>
          <p><strong>Resultado:</strong> {{ player.result }}</p>
          <p><strong>Pontos de liga nesta batalha:</strong> {{ player.season_points }}</p>
          <p><strong>Pontos na temporada antes da alteração:</strong> {{ player.season_total_before }}</p>
          <p><strong>{{ completed ? 'Pontos na temporada após a alteração:' : 'Pontos previstos na temporada após a alteração:' }}</strong> {{ player.season_total_after }}</p>
          <p><strong>Custo da batalha:</strong> {{ -(player.coins || 0) }} moedas</p>
          <p><strong>Premiação:</strong> {{ player.gems }} gemas</p>
        </article>
      </div>
    </section>

    <ng-container *ngIf="completed && summary.change_summary as change">
      <section class="admin-surface detail-section">
        <h3>Estado anterior e estado atual</h3>
        <p>Alteração realizada por {{ change.staff_username }} (ID {{ change.staff_id }}) em {{ change.changed_at | date:'dd/MM/yyyy HH:mm:ss' }}.</p>
        <div class="players">
          <article *ngFor="let player of change.players" class="player-card">
            <h4>{{ player.username }} (ID {{ player.user_id }})</h4>
            <div class="comparison-wrapper">
              <table class="comparison-table">
                <thead><tr><th scope="col">Informação</th><th scope="col">Antes</th><th scope="col">Depois</th></tr></thead>
                <tbody>
                  <tr><th scope="row">Resultado</th><td>{{ player.before.result }}</td><td>{{ player.after.result }}</td></tr>
                  <tr><th scope="row">Score</th><td>{{ player.before.score }}</td><td>{{ player.after.score }}</td></tr>
                  <tr><th scope="row">Pontos de liga nesta batalha</th><td>{{ player.before.season_points }}</td><td>{{ player.after.season_points }}</td></tr>
                  <tr><th scope="row">Total de pontos na temporada atual</th><td>{{ player.before.season_total }}</td><td>{{ player.after.season_total }}</td></tr>
                  <tr><th scope="row">Custo da batalha (moedas)</th><td>{{ -player.before.coins }}</td><td>{{ -player.after.coins }}</td></tr>
                  <tr><th scope="row">Premiação da batalha (gemas)</th><td>{{ player.before.gems }}</td><td>{{ player.after.gems }}</td></tr>
                  <tr><th scope="row">Saldo de gemas</th><td>{{ player.before.gem_balance }}</td><td>{{ player.after.gem_balance }}</td></tr>
                </tbody>
              </table>
            </div>
          </article>
        </div>
      </section>

      <section class="admin-surface detail-section">
        <h3>Transações geradas</h3>
        <div class="players">
          <article *ngFor="let entry of change.transactions" class="player-card transaction-card">
            <h4>{{ entry.direction === 'debit' ? 'Débito' : 'Crédito' }} — {{ entry.username }} ({{ entry.user_id }})</h4>
            <p><strong>ID:</strong> {{ entry.id }}</p>
            <p><strong>Public ID:</strong> {{ entry.public_id }}</p>
            <p><strong>Quantidade:</strong> {{ entry.amount > 0 ? '+' : '' }}{{ entry.amount }} {{ entry.currency === 'gem' ? 'gemas' : entry.currency }}</p>
            <p><strong>Motivo:</strong> {{ entry.type_display }} ({{ entry.type }})</p>
            <p><strong>Status:</strong> {{ entry.status_display }} ({{ entry.status }})</p>
            <p><strong>Data:</strong> {{ entry.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</p>
            <p><strong>Descrição:</strong> {{ entry.description }}</p>
          </article>
        </div>
      </section>
      <div>
        <a class="admin-btn admin-btn--secondary" routerLink="/dashboard/battle-list-finished">Voltar à listagem de batalhas finalizadas</a>
      </div>
    </ng-container>

    <form *ngIf="!completed" #resultForm="ngForm" class="admin-surface detail-section" (ngSubmit)="submit()">
      <h3>Correção do resultado</h3>
      <p>O vencedor atual passará a perder. A premiação será transferida para o outro jogador. Todos os ajustes de pontos serão feitos na temporada atual. A previsão será recalculada ao salvar, conforme o ranking naquele momento.</p>
      <fieldset [disabled]="isSubmitting">
        <label for="loser-result">Novo resultado do vencedor atual</label>
        <select id="loser-result" class="admin-input" name="loserResult" [(ngModel)]="loserResult" required>
          <option value="">Selecione</option>
          <option *ngFor="let option of summary.loser_results" [value]="option.value">{{ option.value }} — {{ option.label }}</option>
        </select>
        <label for="debit-reason">Motivo da remoção de gemas</label>
        <select id="debit-reason" class="admin-input" name="debitTransactionType" [(ngModel)]="debitTransactionType" required>
          <option value="">Selecione</option>
          <option *ngFor="let option of summary.transaction_types" [value]="option.value">{{ option.label }}</option>
        </select>
        <label for="credit-reason">Motivo do recebimento de gemas</label>
        <select id="credit-reason" class="admin-input" name="creditTransactionType" [(ngModel)]="creditTransactionType" required>
          <option value="">Selecione</option>
          <option *ngFor="let option of summary.transaction_types" [value]="option.value">{{ option.label }}</option>
        </select>
        <button type="submit" class="admin-btn admin-btn--primary" [disabled]="resultForm.invalid || isSubmitting">{{ isSubmitting ? 'Salvando…' : 'Salvar alteração de resultado' }}</button>
      </fieldset>
    </form>
  </ng-container>
</section>
